import {SERVER_API_FB_BOT} from '../../constans/index';
import {
    UPDATE_REPLY_STORE_REQUEST,
    UPDATE_REPLY_STORE_SUCCESS,
    UPDATE_REPLY_STORE_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const UpdateReplyStoreAction = (id, dataTarget) => ({

    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_FB_BOT}/api/reply-stores/${id}`;
        },
        method: 'PUT',
        headers: (headers()),
        body: (() => {
            return JSON.stringify(dataTarget);
        }),
        types: [
            UPDATE_REPLY_STORE_REQUEST,
            {
                type: UPDATE_REPLY_STORE_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": UPDATE_REPLY_STORE_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: UPDATE_REPLY_STORE_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": UPDATE_REPLY_STORE_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {UpdateReplyStoreAction}